export default __webpack_public_path__ + "static/media/footer-5.81d49d46.jpg";